export default __webpack_public_path__ + "static/media/company.39664e37.svg";